module.exports = __webpack_public_path__ + "static/media/as_item1_bg.e3fb81c9.png";